import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation } from "@/mixins/index";
import { eventMap, delEventMap } from "@/api/dataAll/dataAll";
import addFuncEvent from "./components/addFuncEvent";
export default {
  name: "eventMapping",
  components: {
    addFuncEvent: addFuncEvent
  },
  mixins: [serchSelect, tabulation],
  data: function data() {
    return {
      total: 0,
      searchData: {
        page: 1,
        page_size: 10,
        func: '',
        event: ''
      },
      tableData: []
    };
  },
  created: function created() {},
  methods: {
    getList: function getList(page) {
      var _this = this;

      this.searchData.page = page;
      eventMap(_objectSpread(_objectSpread({}, this.searchData), {}, {
        game_id: this.rawData.game_id
      })).then(function (res) {
        _this.tableData = res.data.data || [];
        _this.total = res.data.total - 0 || 0;
      });
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.getList(1);
    },
    handleDelete: function handleDelete(id) {
      var _this2 = this;

      this.$confirm(this.$t('confirmDeleteEvent'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delEventMap({
                  id: id,
                  game_id: _this2.rawData.game_id
                }).then(function (res) {
                  _this2.getList();
                });

                _this2.$message({
                  type: "success",
                  message: _this2.$t('deleteSuccessExclamation')
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};